import { createAsyncThunk, createSlice, ActionReducerMapBuilder } from '@reduxjs/toolkit';
import axios from 'axios';
import { ICategory } from '../../../../interfaces';
import store from '../../../app/Store';

const VENDOR_MC_URL = `${process.env.REACT_APP_API_PIM_URL}`;
interface IMapped {
  value: string;
  label: string;
}
interface IState {
  data: ICategory[];
  mappedData: IMapped[];
  loading: boolean;
  done: boolean;
  showError: boolean;
  error: any;
}

const initialState: IState = {
  data: [],
  mappedData: [],
  loading: false,
  done: false,
  showError: false,
  error: null,
};

export const getCategoryList = createAsyncThunk('vendor-category/list', async () => {
  const vendorId = store.getState().auth?.user?.vendor?.id;
  const res = await axios.get<ICategory[]>(`${VENDOR_MC_URL}/${vendorId}/category/leaf/list`);
  return res.data;
});

const categoryListSlice = createSlice({
  name: 'vendor-category',
  initialState,
  reducers: {},
  extraReducers: (builder: ActionReducerMapBuilder<IState>) => {
    builder.addCase(getCategoryList.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getCategoryList.fulfilled, (state, action) => {
      state.data = action.payload;
      state.mappedData = action.payload.map((item) => {
        return {
          value: item.id.toString(),
          label: item.title,
        };
      });
      state.loading = false;
      state.done = true;
    });
    builder.addCase(getCategoryList.rejected, (state, action) => {
      state.error = 'Category List Error!';
      state.showError = true;
    });
  },
});

export default categoryListSlice.reducer;
